import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExternalLink = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	className: "stroke-current ml-1",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10 6H6C4.89543 6 4 6.89543 4 8V18C4 19.1046 4.89543 20 6 20H16C17.1046 20 18 19.1046 18 18V14M14 4H20M20 4V10M20 4L10 14",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		stroke: "currentColor"
	})
});
export default SvgExternalLink;
